import GameScreen from '../components/GameScreen';
import useViewportScale from '../hooks/useViewportScale';

function LobbyScreen({ roomCode, players }) {
  const px = useViewportScale();

  return (
    <GameScreen
      backgroundImage="/lobby-bg.png"
      introSound="/Come On We Need More Poodles.m4a"
      contentPosition="bottom"
      title={`${players.length} player${players.length !== 1 ? 's' : ''} joined!`}
      subtitle={`doodlepoodle.tv code ${roomCode}`}
      players={players}
      playerLayout="grid"
      playerSize={px(200)}
      playerAnimate
      playerPosition={{
        position: 'absolute',
        top: '30%',
        left: '8%',
        width: '50%',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      }}
      style={{ padding: '2rem', paddingBottom: '4rem' }}
    >
    </GameScreen>
  );
}

export default LobbyScreen;
